import { useStore } from 'react-redux';

import { StoreWithReducerManager } from '@/app/providers/store';

export const useAppStore = () => useStore() as StoreWithReducerManager;
